// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-list-item.active {
  background-color: rgba(23, 162, 184, 0.6196078431);
  font-size: 15px;
  font-weight: 500;
  color: #f6f7f8 !important;
}

.cursor_pointer {
  cursor: pointer !important;
}

.mat-list-base .mat-list-item,
.mat-list-base .mat-list-option {
  display: block;
  height: 50px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: 100%;
  padding: 0;
}

.mat-list-base[_ngcontent-gfm-c2] .mat-list-item[_ngcontent-gfm-c2],
.mat-list-base[_ngcontent-gfm-c2] .mat-list-option[_ngcontent-gfm-c2] {
  display: block;
  height: 32px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: auto;
  padding: 0;
}

.vertical-center-icon {
  position: absolute;
  top: 26%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-bottom: 10px;
}

.vertical-center-text {
  position: absolute;
  top: 62%;
  left: 48%;
  transform: translate(-50%, -50%);
  font-size: 11px;
  width: 100%;
  text-align: center;
  letter-spacing: 0px;
  font-size: 9px;
}

.mat-list-base .mat-list-item .mat-list-item-content,
.mat-list-base .mat-list-option .mat-list-item-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0px;
  position: relative;
  height: inherit;
}

.icon-plus {
  font-size: 12px;
  position: absolute;
  left: -23%;
  top: 59%;
}

.icons {
  padding-bottom: 12px;
}

.logo {
  width: auto;
  height: 50px;
  display: inline;
  padding-left: 2%;
  position: relative;
  top: 6%;
}

.sideNav_size {
  width: 6%;
  transform: none;
  visibility: visible;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .sideNav_size {
    width: 7%;
    transform: none;
    visibility: visible;
  }
}
@media screen and (min-width: 580px) and (max-width: 786px) {
  .sideNav_size {
    width: 8%;
    transform: none;
    visibility: visible;
  }
  .vertical-center-text {
    position: absolute;
    top: 62%;
    left: 48%;
    transform: translate(-50%, -50%);
    font-size: 8px;
    width: 100%;
    text-align: center;
    letter-spacing: 0px;
    font-size: 9px;
  }
  .logo {
    width: auto;
    height: 43px;
    display: inline;
    padding-left: 9%;
  }
}
.modal.left .modal-dialog {
  position: fixed;
  right: 0;
  margin: auto;
  width: 320px;
  height: 100%;
  transform: translate3d(0%, 0, 0);
}

.modal.left .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.right .modal-body {
  padding: 15px 15px 80px;
}

.modal.right.fade .modal-dialog {
  left: -320px;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.right.fade.show .modal-dialog {
  right: 0;
}

/* ----- MODAL STYLE ----- */
.modal-content {
  border-radius: 0;
  border: none;
}

.modal-header {
  border-bottom-color: #eeeeee;
  background-color: #fafafa;
}

/* ----- v CAN BE DELETED v ----- */
body {
  background-color: #78909c;
}

.demo {
  padding-top: 60px;
  padding-bottom: 110px;
}

.btn-demo {
  margin: 15px;
  padding: 10px 15px;
  border-radius: 0;
  font-size: 16px;
  background-color: #ffffff;
}

.btn-demo:focus {
  outline: 0;
}

.field_drop {
  width: 68%;
  margin-left: 4%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: 3px;
  background-color: white;
  left: -5px;
}

::ng-deep.cdk-overlay-container {
  isolation: isolate;
  z-index: 1000 !important;
}

::ng-deep.cdk-overlay-container,
.cdk-global-overlay-wrapper,
.cdk-overlay-connected-position-bounding-box {
  isolation: isolate;
  z-index: 9000 !important;
}

.fonts_size_com {
  font-size: 11px !important;
}

::ng-deep.compendium_modal .autocomplete-container .suggestions-container ul li a {
  padding: 14px 15px;
  display: block;
  text-decoration: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
  font-size: 11px !important;
}

.compendium_cast {
  font-size: 11px !important;
}

::ng-deep.compendium_casetype .mat-standard-chip {
  font-size: 11px;
  margin: 0px;
  height: 23px;
  padding-inline: 5px;
  min-height: unset;
}

::ng-deep.compendium_casetype .mat-form-field-wrapper {
  padding: 0px !important;
}

::ng-deep.compendium_casetype .mat-form-field-infix {
  padding: 4px !important;
  padding-bottom: 6px !important;
  padding-top: 0px !important;
}

#sidebars {
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  height: 100%;
}

#sidebar {
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  height: 100%;
  width: 5%;
  background: #17a0b4 !important;
  border-right: 1px solid #ddd;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  color: white;
}
#sidebar .head-nav {
  display: block;
}
#sidebar .listofnavs {
  display: none;
}
#sidebar .labelss {
  display: none;
}
#sidebar .vertical-center-icon {
  position: absolute;
  top: 45%;
  left: 55%;
  transform: translate(-50%, -50%);
  margin-bottom: 10px;
}

#sidebar:hover {
  width: 160px;
  overflow: hidden !important;
}
#sidebar:hover .head-nav {
  display: none;
}
#sidebar:hover .listofnavs {
  display: block;
}
#sidebar:hover .labelss {
  display: block;
  position: absolute;
  top: 41%;
  text-align: center;
  left: 56%;
}
#sidebar:hover .vertical-center-icon {
  position: absolute;
  top: 45%;
  left: 13%;
  transform: translate(-50%, -50%);
  margin-bottom: 10px;
}

.scrollbar {
  height: 90%;
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}

.logo_side {
  height: 35px;
  margin-block: 11%;
  margin-left: 19%;
  margin-bottom: 20%;
  display: block;
}

.logo_side_full {
  display: block;
  margin-left: 26%;
  margin-bottom: 27%;
  margin-top: 13%;
  height: 30px;
}

.scrollbar:hover {
  height: 90%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

/* Scrollbar Style */
#style-1::-webkit-scrollbar-track {
  border-radius: 2px;
}

#style-1::-webkit-scrollbar {
  width: 5px;
  background-color: #f7f7f7;
}

#style-1::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #bfbfbf;
}

.panelsicon {
  font-size: 20px;
  margin-left: 36%;
  margin-right: 6%;
  cursor: pointer;
  margin-block: 18%;
}

.panels {
  display: none;
}

::ng-deep.main-menu:hover .mat-expansion-indicator::after {
  color: inherit !important;
  display: block !important;
}

.main-menu:hover,
nav.main-menu.expanded {
  width: 182px;
  overflow: hidden;
  opacity: 1;
  background-color: #304065;
  color: white;
}
.main-menu:hover .logo_side,
nav.main-menu.expanded .logo_side {
  display: none;
}
.main-menu:hover .panelsicon,
nav.main-menu.expanded .panelsicon {
  display: none;
}
.main-menu:hover .panels,
nav.main-menu.expanded .panels {
  display: block;
}
.main-menu:hover .main-menu .mat-expansion-indicator::after,
nav.main-menu.expanded .main-menu .mat-expansion-indicator::after {
  color: inherit !important;
  display: block !important;
}
.main-menu:hover .logo_side_full,
nav.main-menu.expanded .logo_side_full {
  margin-left: 6%;
  margin-bottom: 3%;
  margin-top: 4%;
  height: 1%;
  width: 79%;
}
.main-menu:hover li,
nav.main-menu.expanded li {
  color: white;
}

.main-menu {
  background-color: #304065;
  color: white !important;
  top: 0;
  bottom: 0;
  height: 100%;
  left: 0;
  width: 55px;
  overflow: hidden;
  cursor: pointer;
  transition: width 0.2s linear;
  box-shadow: 1px 0 15px rgba(0, 0, 0, 0.07);
  opacity: 1;
  font-weight: 200;
}

.main-menu:hover {
  overflow-x: hidden;
}

.main-menu > ul {
  margin: 7px 0;
}

.main-menu li {
  position: relative;
  width: 255px;
  display: block;
  border-collapse: collapse;
  border-spacing: 0;
  color: white;
  font-size: 13px;
  text-decoration: none;
  transition: all 0.14s linear;
  font-family: "Strait", sans-serif;
  height: 39px;
}

.main-menu .nav-text {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 190px;
  font-family: "Titillium Web", sans-serif;
  height: 39px;
  padding-block: 4%;
  margin-left: 1px;
}

nav {
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}

nav ul,
nav li {
  outline: 0;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}

.main-menu li.active {
  color: #fff;
  background-color: #00bbbb;
}

.main-menu li:hover,
.main-menu li.active,
.dropdown-menu > li:hover,
.dropdown-menu > li > :focus,
.dropdown-menu > .active,
.dropdown-menu > .active:hover,
.dropdown-menu > .active:focus,
.no-touch .dashboard-page nav.dashboard-menu ul li:hover,
.dashboard-page nav.dashboard-menu ul li.active {
  color: #fff;
  background-color: #00bbbb;
  cursor: pointer;
}

::ng-deep.main-menu .mat-expansion-panel-header {
  background-color: #304065 !important;
  color: white !important;
  line-height: 12px;
  border-radius: unset !important;
  padding-left: 10%;
}

::ng-deep.main-menu .mat-expansion-panel {
  background-color: #304065 !important;
  color: white !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

::ng-deep.main-menu .mat-expansion-panel-header-title {
  color: white !important;
}

::ng-deep.main-menu .mat-expansion-panel-header-title:hover {
  color: #fff !important;
}

::ng-deep.main-menu .mat-expansion-panel-header:hover {
  color: #fff !important;
  background-color: #00bbbb !important;
}

.username_fonticon {
  font-size: 18px;
  top: 8px;
  position: relative;
  right: 1%;
}

.logout_fonticon {
  position: relative;
  top: 10px;
  font-size: 20px;
  right: 3px;
  cursor: pointer;
}

.userrole {
  font-size: 13px;
  position: relative;
  color: #05bdd5;
  width: -moz-fit-content;
  width: fit-content;
  padding-right: 2%;
}

.svg_userrole {
  position: absolute;
  color: black;
  font-size: 21px;
  top: -5px;
}

.svg_timzone {
  position: absolute;
  color: black;
  font-size: 16px;
  top: -1px;
}

.locklabel_style {
  left: 4%;
}

::ng-deep.main-menu .mat-expansion-panel-header {
  color: white;
  height: 39px !important;
}

::ng-deep.main-menu .mat-expansion-panel-body {
  background-color: #304065;
  padding: 0 !important;
  max-height: 165px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.accroidiaon_label {
  left: 7%;
  top: 20%;
  font-size: 13px;
}

.caret_css {
  color: black;
  cursor: pointer;
  font-size: 14px;
  position: relative;
  top: 1px;
}

.roles_css {
  min-height: 30px !important;
  width: 170px !important;
}
.roles_css .mat-ripple .mat-mdc-menu-ripple {
  height: 30px !important;
}

::ng-deep.mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text {
  font-size: 12px !important;
}

.mat-mdc-menu-item-text {
  font-size: 12px !important;
}

.highlightedRole {
  min-height: 30px !important;
  width: 180px !important;
  background-color: #17a2b8;
  color: white;
}
.highlightedRole .mat-ripple .mat-mdc-menu-ripple {
  height: 30px !important;
}

.highlightedRole:hover {
  min-height: 30px !important;
  width: 180px !important;
  color: #17a2b8 !important;
  cursor: pointer;
}
.highlightedRole:hover .mat-ripple .mat-mdc-menu-ripple {
  height: 30px !important;
}

.lock_icon_style {
  position: fixed;
  bottom: 10%;
  left: 0;
  right: 0;
  cursor: pointer;
}

.maticon_style {
  position: relative;
  top: 6px;
  font-size: 22px;
  margin-left: 7%;
  margin-right: 6%;
  cursor: pointer;
}

.fa_fonts {
  position: relative;
  top: 7%;
  font-size: 20px;
  margin-left: 7%;
  margin-right: 6%;
  cursor: pointer;
}

.fa_fonts_lock {
  position: relative;
  top: 7%;
  font-size: 20px;
  margin-left: 8%;
  margin-right: 6%;
  cursor: pointer;
}

.fa_fonts_fork {
  position: relative;
  top: 7%;
  font-size: 20px;
  margin-left: 9%;
  margin-right: 8%;
  cursor: pointer;
}

.createfork {
  position: relative;
  top: 5%;
  margin-left: 9%;
  margin-right: 8%;
  cursor: pointer;
}

.fa_fonts_submenu {
  position: relative;
  left: 0;
  top: 0%;
  font-size: 20px;
  cursor: pointer;
}

::ng-deep.main-menu .mat-expansion-panel-header {
  padding: 0 6px 0 18px !important;
}

::ng-deep.main-menu .mat-expansion-indicator::after {
  color: inherit !important;
  display: none !important;
}

.submenu_li {
  height: 21px !important;
  padding-left: 18% !important;
  padding-block: 3% !important;
}

.role_icon {
  width: 15px !important;
  position: relative !important;
  top: -1px !important;
  cursor: pointer !important;
}

.mat_icon_normal {
  font-size: 22px;
  margin-left: 7%;
  margin-right: 6%;
  cursor: pointer;
  margin-block: 4%;
}

.sublist_icon {
  font-size: 18px;
  position: relative;
  top: 2px;
}

.nav_height {
  max-height: 80vh !important;
  overflow-x: hidden;
  overflow-y: overlay;
}

.menu_show {
  margin-left: 56px;
  overflow-x: hidden;
  height: 93vh !important;
}

.menu_hide {
  margin-left: 0px !important;
  overflow-x: hidden !important;
  height: 100vh !important;
}

::ng-deep.mat_tab_styles .mat-mdc-tab-label-container {
  background-color: #dbdada !important;
}
::ng-deep.mat_tab_styles .mat-mdc-tab-label-container .mat-mdc-tab-labels {
  height: 30px !important;
}
::ng-deep.mat_tab_styles .mat-mdc-tab-label-container .mat-mdc-tab {
  font-weight: 600;
  font-size: 12px;
  bottom: 6px;
  letter-spacing: normal;
  border-right: 1px solid #bfbfbf;
}
::ng-deep.mat_tab_styles .mat-mdc-tab-label-container .mat-mdc-tab .mdc-tab__text-label {
  position: relative;
  bottom: 7%;
  color: black;
}
::ng-deep.mat_tab_styles .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active {
  background-color: white !important;
  opacity: unset !important;
}
::ng-deep.mat_tab_styles .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #17a0b4 !important;
}
::ng-deep.mat_tab_styles .mat-mdc-tab-label-container .mat-mdc-tab.mdc-tab--active .mdc-tab-indicator .mdc-tab-indicator__content {
  background-color: #17a0b4 !important;
  height: 14px;
  border-color: transparent;
}
::ng-deep.mat_tab_styles .mat-mdc-tab-body-wrapper .mat-mdc-tab-body-content {
  overflow-y: auto;
  overflow-x: hidden;
}

::ng-deep.matoutlinestyles.mat-mdc-form-field {
  width: 100%;
}
::ng-deep.matoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 8px !important;
}
::ng-deep.matoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  height: 30px !important;
}
::ng-deep.matoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline .mdc-floating-label {
  font-size: 11px !important;
}
::ng-deep.matoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-input-element {
  position: relative;
  font-size: 12px !important;
}
::ng-deep.matoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  bottom: 11px !important;
}
::ng-deep.matoutlinestyles.mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.mat-mdc-option {
  font-size: 12px !important;
}

::ng-deep.mat-mdc-select {
  font-size: 12px !important;
}

::ng-deep.modal-backdrop.show {
  height: 84vh;
  top: 16%;
  width: 95vw;
  left: 4.5%;
  z-index: 1049 !important;
}

::ng-deep .modal.show {
  z-index: 1050 !important;
  height: 80vh;
  width: 88vw;
  left: 12%;
  top: 16%;
}

::ng-deep mat-sidenav-container {
  z-index: 1040 !important;
  position: relative;
  isolation: isolate;
}

::ng-deep mat-sidenav {
  z-index: 1040 !important;
  position: relative;
  isolation: isolate;
}

::ng-deep .mat-tab-header {
  z-index: 1040 !important;
  position: relative;
}

::ng-deep .mat-tab-group {
  position: relative;
  z-index: 1040 !important;
}

::ng-deep .mdc-switch:enabled .mdc-switch__track::after {
  background: #17a0b4 !important;
}

::ng-deep.mat-mdc-slide-toggle {
  --mdc-switch-selected-pressed-handle-color:\$btn-color;
}

::ng-deep.mat-mdc-slide-toggle-checked .mdc-switch__shadow {
  background-color: #17a0b4 !important;
}

::ng-deep.matchipstyles .mat-mdc-form-field {
  width: 100% !important;
  position: relative !important;
  bottom: 8px !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: white !important;
  overflow-y: auto !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding-top: 5px !important;
  max-height: 250px !important;
  padding-bottom: 0px !important;
  min-height: 42px !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  display: flex !important;
  padding-top: 5px !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px !important;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-focused .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
::ng-deep.matchipstyles .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: #17a0b4 !important;
}
::ng-deep.mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__inner-circle {
  border-color: #17a0b4 !important;
}

::ng-deep.matselectstyles {
  font-size: 11px !important;
  border-radius: 5px !important;
  height: 30px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  overflow: auto;
}
::ng-deep.matselectstyles .mat-mdc-text-field-wrapper {
  background-color: white !important;
}
::ng-deep.matselectstyles .mat-mdc-text-field-wrapper .mat-mdc-select {
  position: relative !important;
  bottom: 13px !important;
  font-size: 11px !important;
}
::ng-deep.matselectstyles .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.matselectstyles .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background {
  background-color: #17a0b4 !important;
  border-color: #17a0b4 !important;
}
::ng-deep.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background .mdc-checkbox__mixedmark {
  border-color: white !important;
}

::ng-deep.tabclosebtn .mat-mdc-button-persistent-ripple {
  display: none !important;
}
::ng-deep.tabclosebtn .mat-mdc-focus-indicator {
  display: none !important;
}
::ng-deep.tabclosebtn .mat-mdc-button-touch-target {
  display: none !important;
}
::ng-deep.tabclosebtn .mat-ripple .mat-mdc-button-ripple {
  display: none !important;
}

.no-records {
  justify-content: center;
  align-items: center;
  display: flex;
  height: 100%;
  width: 100%;
  font-size: 18px;
  color: rgba(128, 128, 128, 0.7098039216);
}

.timezone-switch {
  margin-left: 18px;
}

.timezone-switch .svg_userrole {
  color: #1976d2;
}

::ng-deep.timezone-dropdown-panel .mat-mdc-menu-content {
  padding-block: 0 !important;
  min-width: 80px !important;
  width: 80px !important;
}

::ng-deep.timezone-dropdown-panel.mat-mdc-menu-panel {
  min-height: 0 !important;
  min-width: 80px !important;
  width: 80px !important;
}

.timezone-dropdown-item {
  min-height: 30px !important;
  width: 80px !important;
  color: #333;
  font-size: 12px !important;
}
.timezone-dropdown-item .mat-ripple .mat-mdc-menu-ripple {
  height: 30px !important;
}

.timezone-dropdown-item-selected {
  min-height: 30px !important;
  width: 80px !important;
  background-color: #17a2b8;
  color: white;
  font-weight: bold;
  font-size: 12px !important;
}
.timezone-dropdown-item-selected .mat-ripple .mat-mdc-menu-ripple {
  height: 30px !important;
}

.timezone-dropdown-item-selected:hover {
  min-height: 30px !important;
  width: 80px !important;
  color: #17a2b8 !important;
  cursor: pointer;
}
.timezone-dropdown-item-selected:hover .mat-ripple .mat-mdc-menu-ripple {
  height: 30px !important;
}

::ng-deep.roles-dropdown-panel .mat-mdc-menu-content {
  padding-block: 0 !important;
  min-width: 180px !important;
}

::ng-deep.roles-dropdown-panel.mat-mdc-menu-panel {
  min-height: 0 !important;
  min-width: 180px !important;
}

::ng-deep .cdk-overlay-pane:has(.roles_dropdown_style.mat-mdc-menu-panel) {
  align-self: auto !important;
}

.lock_screen_modal {
  z-index: 10000 !important;
  height: 101vh !important;
  width: 100% !important;
  left: 0% !important;
  top: 0% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/homepage/homepage.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAGA;EACE,kDAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAFF;;AAIA;EACE,0BAAA;AADF;;AAGA;;EAEE,cAAA;EACA,YAAA;EACA,6CAAA;EACA,WAAA;EACA,UAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,YAAA;EACA,6CAAA;EACA,WAAA;EACA,UAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;EACA,mBAAA;AADF;;AAIA;EACE;IACE,SAAA;IACA,eAAA;IACA,mBAAA;EADF;AACF;AAIA;EACE;IACE,SAAA;IACA,eAAA;IACA,mBAAA;EAFF;EAKA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,cAAA;EAHF;EAMA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAJF;AACF;AAOA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EAIA,gCAAA;AALF;;AAQA;EACE,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,YAAA;EAUA,mDACE;AAZJ;;AAgBA;EACE,QAAA;AAbF;;AAgBA,4BAAA;AACA;EACE,gBAAA;EACA,YAAA;AAbF;;AAgBA;EACE,4BAAA;EACA,yBAAA;AAbF;;AAgBA,mCAAA;AACA;EACE,yBAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,qBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAbF;;AAgBA;EACE,UAAA;AAbF;;AAgBA;EACE,UAAA;EACA,eAAA;EACA,+GACE;EAGF,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,UAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,wBAAA;AAhBF;;AAmBA;;;EAGE,kBAAA;EACA,wBAAA;AAhBF;;AAuBA;EACE,0BAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EACA,0BAAA;AApBF;;AAuBA;EACE,0BAAA;AApBF;;AAuBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AApBF;;AAuBA;EACE,uBAAA;AApBF;;AAuBA;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;AApBF;;AAwBA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AArBF;;AAwBA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,8BCtRU;EDuRV,4BAAA;EACA,gCAAA;EACA,gBAAA;EACA,YAAA;AArBF;AAuBE;EACE,cAAA;AArBJ;AAwBE;EACE,aAAA;AAtBJ;AAyBE;EACE,aAAA;AAvBJ;AA0BE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;AAxBJ;;AA4BA;EACE,YAAA;EACA,2BAAA;AAzBF;AA2BE;EACE,aAAA;AAzBJ;AA4BE;EACE,cAAA;AA1BJ;AA6BE;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;AA5BJ;;AAgCA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AA7BF;;AAgCA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AA7BF;;AAgCA,oBAAA;AACA;EACE,kBAAA;AA7BF;;AAgCA;EACE,UAAA;EACA,yBAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,yBAAA;AA7BF;;AAgCA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,aAAA;AA7BF;;AA+BA;EACE,yBAAA;EACA,yBAAA;AA5BF;;AA8BA;;EAEE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;AA3BF;AA6BE;;EACE,aAAA;AA1BJ;AA6BE;;EACE,aAAA;AA1BJ;AA6BE;;EACE,cAAA;AA1BJ;AA4BE;;EACE,yBAAA;EACA,yBAAA;AAzBJ;AA4BE;;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;AAzBJ;AA4BE;;EACE,YAAA;AAzBJ;;AA6BA;EACE,yBAAA;EACA,uBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EAEA,6BAAA;EACA,0CAAA;EACA,UAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,aAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EAEA,4BAAA;EACA,iCAAA;EACA,YAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,yBAAA;EAGA,oBAAA;EACA,iBAAA;AA1BF;;AA6BA;;EAEE,UAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,yBAAA;AA1BF;;AA6BA;;;;;;;;;EASE,WAAA;EACA,yBAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;AA1BF;;AA6BA;EACE,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AA1BF;;AA6BA;EACE,uBAAA;AA1BF;;AA6BA;EACE,sBAAA;AA1BF;;AA6BA;EACE,sBAAA;EACA,oCAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EAAA,kBAAA;EACA,iBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AA1BF;;AA4BA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AAzBF;;AA4BA;EACE,QAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,uBAAA;AAzBF;;AA4BA;EACE,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,QAAA;EACA,QAAA;EACA,eAAA;AAzBF;;AA6BA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AA1BF;;AA6BA;EACA,2BAAA;EACA,uBAAA;AA1BA;AA4BA;EACE,uBAAA;AA1BF;;AA6BA;EACE,0BAAA;AA1BF;;AA4BA;EACE,0BAAA;AAzBF;;AA2BA;EACE,2BAAA;EACF,uBAAA;EAKE,yBAAA;EACA,YAAA;AA5BF;AAwBA;EACE,uBAAA;AAtBF;;AA4BA;EACE,2BAAA;EACF,uBAAA;EAKE,yBAAA;EACA,eAAA;AA7BF;AAyBA;EACE,uBAAA;AAvBF;;AA6BA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,OAAA;EACA,OAAA;EACA,eAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,gCAAA;AA1BF;;AA6BA;EACE,yBAAA;EACA,wBAAA;AA1BF;;AA6BA;EACE,uBAAA;EACA,4BAAA;EACA,4BAAA;AA1BF;;AA6BA;EACE,sBAAA;EACA,6BAAA;EACA,oBAAA;EACA,0BAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;AA1BF;;AA6BA;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;AA1BF;;AA6BA;EACE,iBAAA;EACA,kBAAA;EACA,uBAAA;AA1BF;;AA6BA;EACE,2BAAA;EACA,6BAAA;EACA,wBAAA;AA1BF;;AA6BE;EACE,oCAAA;AA1BJ;AA2BE;EACE,uBAAA;AAzBJ;AA2BE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,+BAAA;AAzBJ;AA4BI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AA1BN;AA6BI;EACE,kCAAA;EACA,yBAAA;AA3BN;AA4BM;EACA,yBAAA;AA1BN;AA6BI;EACE,oCAAA;EACF,YAAA;EACA,yBAAA;AA3BJ;AAgCE;EACE,gBAAA;EACA,kBAAA;AA9BJ;;AAkCE;EACE,WAAA;AA/BJ;AAgCI;EACE,uBAAA;AA9BN;AAiCM;EACE,uBAAA;AA/BR;AAgCQ;EACI,0BAAA;AA9BZ;AAgCQ;EACE,kBAAA;EACA,0BAAA;AA9BV;AAgCQ;EACE,uBAAA;AA9BV;AAkCG;EACC,wBAAA;AAhCJ;;AAmCE;EACE,0BAAA;AAhCJ;;AAkCE;EACE,0BAAA;AA/BJ;;AAkCA;EACE,YAAA;EACE,QAAA;EACA,WAAA;EACA,UAAA;EACF,wBAAA;AA/BF;;AAkCA;EACE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AA/BF;;AAkCA;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;AA/BF;;AAiCA;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;AA9BF;;AAgCA;EACE,wBAAA;EACA,kBAAA;AA7BF;;AA+BA;EACE,kBAAA;EACA,wBAAA;AA5BF;;AA+BE;EACA,8BCt2BU;AD00BZ;;AA+BA;EACE,qDAAA;AA5BF;;AA8BA;EACG,oCC72BS;ADk1BZ;;AA+BG;EACC,sBAAA;EACA,6BAAA;EACA,sBAAA;AA5BJ;AA6BI;EACE,kCAAA;EACA,2BAAA;AA3BN;AA4BM;EACE,wBAAA;AA1BR;AA4BM;EACE,kCAAA;AA1BR;AA4BM;EACE,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;AA1BR;AA2BQ;EACE,0BAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;AAzBV;AA2BQ;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAzBV;AA0BU;EACE,0BAAA;AAxBZ;AA8BM;EACA,kCAAA;AA5BN;AA6BM;EACE,wBAAA;AA3BR;AA6BM;EACE,kCAAA;AA3BR;AA6BM;EACE,wBAAA;EACA,2BAAA;AA3BR;AA4BQ;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AA1BV;AA4BQ;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AA1BV;AA2BU;EACE,0BAAA;AAzBZ;AA8BM;EACE,wBAAA;AA5BR;AA+BI;EACE,wBAAA;AA7BN;;AAiCI;EACA,gCCz7BQ;AD25BZ;AAgCI;EACE,gCC57BM;AD85BZ;;AAiCE;EACE,0BAAA;EACA,6BAAA;EACA,uBAAA;EACA,yCAAA;EACA,cAAA;AA9BJ;AA+BI;EACE,kCAAA;AA7BN;AA8BM;EACE,6BAAA;EACA,uBAAA;EACA,0BAAA;AA5BR;AA8BM;EACE,wBAAA;AA5BR;AA+BK;EACD,wBAAA;AA7BJ;;AAgCE;EACE,oCCr9BQ;EDs9BR,gCCt9BQ;ADy7BZ;AA8BI;EACE,8BAAA;AA5BN;;AAiCI;EACE,wBAAA;AA9BN;AAgCI;EACE,wBAAA;AA9BN;AAgCI;EACE,wBAAA;AA9BN;AAgCI;EACE,wBAAA;AA9BN;;AAkCA;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,wCAAA;AA/BJ;;AAiCA;EACE,iBAAA;AA9BF;;AAiCA;EACE,cAAA;AA9BF;;AAkCA;EACE,2BAAA;EACA,0BAAA;EACA,sBAAA;AA/BF;;AAkCA;EACE,wBAAA;EACA,0BAAA;EACA,sBAAA;AA/BF;;AAmCA;EACE,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,0BAAA;AAhCF;AAkCE;EACE,uBAAA;AAhCJ;;AAoCA;EACE,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AAjCF;AAmCE;EACE,uBAAA;AAjCJ;;AAqCA;EACE,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AAlCF;AAoCE;EACE,uBAAA;AAlCJ;;AAuCA;EACE,2BAAA;EACA,2BAAA;AApCF;;AAuCA;EACE,wBAAA;EACA,2BAAA;AApCF;;AAwCA;EACE,2BAAA;AArCF;;AAwCA;EACE,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AArCF","sourcesContent":["\r\n@import \"../../variables.scss\";\r\n\r\n.mat-list-item.active {\r\n  background-color: #17a2b89e;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #f6f7f8 !important;\r\n}\r\n.cursor_pointer {\r\n  cursor: pointer !important;\r\n}\r\n.mat-list-base .mat-list-item,\r\n.mat-list-base .mat-list-option {\r\n  display: block;\r\n  height: 50px;\r\n  -webkit-tap-highlight-color: #0000;\r\n  width: 100%;\r\n  padding: 0;\r\n}\r\n\r\n.mat-list-base[_ngcontent-gfm-c2] .mat-list-item[_ngcontent-gfm-c2],\r\n.mat-list-base[_ngcontent-gfm-c2] .mat-list-option[_ngcontent-gfm-c2] {\r\n  display: block;\r\n  height: 32px;\r\n  -webkit-tap-highlight-color: #0000;\r\n  width: auto;\r\n  padding: 0;\r\n}\r\n\r\n.vertical-center-icon {\r\n  position: absolute;\r\n  top: 26%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.vertical-center-text {\r\n  position: absolute;\r\n  top: 62%;\r\n  left: 48%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 11px;\r\n  width: 100%;\r\n  text-align: center;\r\n  letter-spacing: 0px;\r\n  font-size: 9px;\r\n}\r\n\r\n.mat-list-base .mat-list-item .mat-list-item-content,\r\n.mat-list-base .mat-list-option .mat-list-item-content {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n  padding: 0 0px;\r\n  position: relative;\r\n  height: inherit;\r\n}\r\n\r\n.icon-plus {\r\n  font-size: 12px;\r\n  position: absolute;\r\n  left: -23%;\r\n  top: 59%;\r\n}\r\n\r\n.icons {\r\n  padding-bottom: 12px;\r\n}\r\n\r\n\r\n.logo {\r\n  width: auto;\r\n  height: 50px;\r\n  display: inline;\r\n  padding-left: 2%;\r\n  position: relative;\r\n  top: 6%;\r\n}\r\n\r\n.sideNav_size {\r\n  width: 6%;\r\n  transform: none;\r\n  visibility: visible;\r\n}\r\n\r\n@media screen and (min-width: 900px) and (max-width: 1024px) {\r\n  .sideNav_size {\r\n    width: 7%;\r\n    transform: none;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 580px) and (max-width: 786px) {\r\n  .sideNav_size {\r\n    width: 8%;\r\n    transform: none;\r\n    visibility: visible;\r\n  }\r\n\r\n  .vertical-center-text {\r\n    position: absolute;\r\n    top: 62%;\r\n    left: 48%;\r\n    transform: translate(-50%, -50%);\r\n    font-size: 8px;\r\n    width: 100%;\r\n    text-align: center;\r\n    letter-spacing: 0px;\r\n    font-size: 9px;\r\n  }\r\n\r\n  .logo {\r\n    width: auto;\r\n    height: 43px;\r\n    display: inline;\r\n    padding-left: 9%;\r\n  }\r\n}\r\n\r\n.modal.left .modal-dialog {\r\n  position: fixed;\r\n  right: 0;\r\n  margin: auto;\r\n  width: 320px;\r\n  height: 100%;\r\n  -webkit-transform: translate3d(0%, 0, 0);\r\n  -ms-transform: translate3d(0%, 0, 0);\r\n  -o-transform: translate3d(0%, 0, 0);\r\n  transform: translate3d(0%, 0, 0);\r\n}\r\n\r\n.modal.left .modal-content {\r\n  height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal.right .modal-body {\r\n  padding: 15px 15px 80px;\r\n}\r\n\r\n.modal.right.fade .modal-dialog {\r\n  left: -320px;\r\n  -webkit-transition:\r\n    opacity 0.3s linear,\r\n    left 0.3s ease-out;\r\n  -moz-transition:\r\n    opacity 0.3s linear,\r\n    left 0.3s ease-out;\r\n  -o-transition:\r\n    opacity 0.3s linear,\r\n    left 0.3s ease-out;\r\n  transition:\r\n    opacity 0.3s linear,\r\n    left 0.3s ease-out;\r\n}\r\n\r\n.modal.right.fade.show .modal-dialog {\r\n  right: 0;\r\n}\r\n\r\n/* ----- MODAL STYLE ----- */\r\n.modal-content {\r\n  border-radius: 0;\r\n  border: none;\r\n}\r\n\r\n.modal-header {\r\n  border-bottom-color: #eeeeee;\r\n  background-color: #fafafa;\r\n}\r\n\r\n/* ----- v CAN BE DELETED v ----- */\r\nbody {\r\n  background-color: #78909c;\r\n}\r\n\r\n.demo {\r\n  padding-top: 60px;\r\n  padding-bottom: 110px;\r\n}\r\n\r\n.btn-demo {\r\n  margin: 15px;\r\n  padding: 10px 15px;\r\n  border-radius: 0;\r\n  font-size: 16px;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.btn-demo:focus {\r\n  outline: 0;\r\n}\r\n\r\n.field_drop {\r\n  width: 68%;\r\n  margin-left: 4%;\r\n  box-shadow:\r\n    0 1px 3px 0 rgb(0 0 0 / 20%),\r\n    0 1px 1px 0 rgb(0 0 0 / 14%),\r\n    0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  top: 3px;\r\n  background-color: white;\r\n  left: -5px;\r\n}\r\n\r\n::ng-deep.cdk-overlay-container {\r\n  isolation: isolate;\r\n  z-index: 1000 !important;\r\n}\r\n\r\n::ng-deep.cdk-overlay-container,\r\n.cdk-global-overlay-wrapper,\r\n.cdk-overlay-connected-position-bounding-box {\r\n  isolation: isolate;\r\n  z-index: 9000 !important;\r\n  //height: 84vh;\r\n  //width: 95vw;\r\n  //top: 16%;\r\n  //left: 4.5%;\r\n}\r\n\r\n.fonts_size_com {\r\n  font-size: 11px !important;\r\n}\r\n\r\n::ng-deep.compendium_modal .autocomplete-container .suggestions-container ul li a {\r\n  padding: 14px 15px;\r\n  display: block;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  font-size: 11px !important;\r\n}\r\n\r\n.compendium_cast {\r\n  font-size: 11px !important;\r\n}\r\n\r\n::ng-deep.compendium_casetype .mat-standard-chip {\r\n  font-size: 11px;\r\n  margin: 0px;\r\n  height: 23px;\r\n  padding-inline: 5px;\r\n  min-height: unset;\r\n}\r\n\r\n::ng-deep.compendium_casetype .mat-form-field-wrapper {\r\n  padding: 0px !important;\r\n}\r\n\r\n::ng-deep.compendium_casetype .mat-form-field-infix {\r\n  padding: 4px !important;\r\n  padding-bottom: 6px !important;\r\n  padding-top: 0px !important;\r\n}\r\n\r\n// !<--- sidenavBarCss ---->\r\n#sidebars {\r\n  position: fixed;\r\n  z-index: 10;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n}\r\n\r\n#sidebar {\r\n  position: fixed;\r\n  z-index: 10;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 5%;\r\n  background: $btn-color;\r\n  border-right: 1px solid #ddd;\r\n  transition: all 0.3s ease-in-out;\r\n  overflow: hidden;\r\n  color: white;\r\n\r\n  .head-nav {\r\n    display: block;\r\n  }\r\n\r\n  .listofnavs {\r\n    display: none;\r\n  }\r\n\r\n  .labelss {\r\n    display: none;\r\n  }\r\n\r\n  .vertical-center-icon {\r\n    position: absolute;\r\n    top: 45%;\r\n    left: 55%;\r\n    transform: translate(-50%, -50%);\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n#sidebar:hover {\r\n  width: 160px;\r\n  overflow: hidden !important;\r\n\r\n  .head-nav {\r\n    display: none;\r\n  }\r\n\r\n  .listofnavs {\r\n    display: block;\r\n  }\r\n\r\n  .labelss {\r\n    display: block;\r\n    position: absolute;\r\n    top: 41%;\r\n    text-align: center;\r\n    left: 56%;\r\n  }\r\n\r\n  .vertical-center-icon {\r\n    position: absolute;\r\n    top: 45%;\r\n    left: 13%;\r\n    transform: translate(-50%, -50%);\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n.scrollbar {\r\n  height: 90%;\r\n  width: 100%;\r\n  overflow-y: hidden;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.logo_side {\r\n  height: 35px;\r\n  margin-block: 11%;\r\n  margin-left: 19%;\r\n  margin-bottom: 20%;\r\n  display: block;\r\n}\r\n\r\n.logo_side_full {\r\n  display: block;\r\n  margin-left: 26%;\r\n  margin-bottom: 27%;\r\n  margin-top: 13%;\r\n  height: 30px;\r\n}\r\n\r\n.scrollbar:hover {\r\n  height: 90%;\r\n  width: 100%;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* Scrollbar Style */\r\n#style-1::-webkit-scrollbar-track {\r\n  border-radius: 2px;\r\n}\r\n\r\n#style-1::-webkit-scrollbar {\r\n  width: 5px;\r\n  background-color: #f7f7f7;\r\n}\r\n\r\n#style-1::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  background-color: #bfbfbf;\r\n}\r\n\r\n.panelsicon {\r\n  font-size: 20px;\r\n  margin-left: 36%;\r\n  margin-right: 6%;\r\n  cursor: pointer;\r\n  margin-block: 18%;\r\n}\r\n\r\n.panels {\r\n  display: none;\r\n}\r\n::ng-deep.main-menu:hover .mat-expansion-indicator::after {\r\n  color: inherit !important;\r\n  display: block !important;\r\n}\r\n.main-menu:hover,\r\nnav.main-menu.expanded {\r\n  width: 182px;\r\n  overflow: hidden;\r\n  opacity: 1;\r\n  background-color: #304065;\r\n  color: white;\r\n\r\n  .logo_side {\r\n    display: none;\r\n  }\r\n\r\n  .panelsicon {\r\n    display: none;\r\n  }\r\n\r\n  .panels {\r\n    display: block;\r\n  }\r\n  .main-menu .mat-expansion-indicator::after {\r\n    color: inherit !important;\r\n    display: block !important;\r\n  }\r\n\r\n  .logo_side_full {\r\n    margin-left: 6%;\r\n    margin-bottom: 3%;\r\n    margin-top: 4%;\r\n    height: 1%;\r\n    width: 79%;\r\n  }\r\n\r\n  li {\r\n    color: white;\r\n  }\r\n}\r\n\r\n.main-menu {\r\n  background-color: #304065;\r\n  color: white !important;\r\n  top: 0;\r\n  bottom: 0;\r\n  height: 100%;\r\n  left: 0;\r\n  width: 55px;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  -webkit-transition: width 0.2s linear;\r\n  transition: width 0.2s linear;\r\n  box-shadow: 1px 0 15px rgba(0, 0, 0, 0.07);\r\n  opacity: 1;\r\n  font-weight: 200;\r\n}\r\n\r\n.main-menu:hover {\r\n  overflow-x: hidden;\r\n}\r\n\r\n.main-menu > ul {\r\n  margin: 7px 0;\r\n}\r\n\r\n.main-menu li {\r\n  position: relative;\r\n  width: 255px;\r\n  display: block;\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n  color: white;\r\n  font-size: 13px;\r\n  text-decoration: none;\r\n  -webkit-transition: all 0.14s linear;\r\n  transition: all 0.14s linear;\r\n  font-family: \"Strait\", sans-serif;\r\n  height: 39px;\r\n}\r\n\r\n.main-menu .nav-text {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 190px;\r\n  font-family: \"Titillium Web\", sans-serif;\r\n  height: 39px;\r\n  padding-block: 4%;\r\n  margin-left: 1px;\r\n}\r\n\r\nnav {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  -o-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\nnav ul,\r\nnav li {\r\n  outline: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.main-menu li.active {\r\n  color: #fff;\r\n  background-color: #00bbbb;\r\n}\r\n\r\n.main-menu li:hover,\r\n.main-menu li.active,\r\n.dropdown-menu > li:hover,\r\n.dropdown-menu > li > :focus,\r\n.dropdown-menu > .active,\r\n.dropdown-menu > .active:hover,\r\n.dropdown-menu > .active:focus,\r\n.no-touch .dashboard-page nav.dashboard-menu ul li:hover,\r\n.dashboard-page nav.dashboard-menu ul li.active {\r\n  color: #fff;\r\n  background-color: #00bbbb;\r\n  cursor: pointer;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel-header {\r\n  background-color: #304065 !important;\r\n  color: white !important;\r\n  line-height: 12px;\r\n  border-radius: unset !important;\r\n  padding-left: 10%;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel {\r\n  background-color: #304065 !important;\r\n  color: white !important;\r\n  box-shadow: none !important;\r\n  border-radius: 0 !important;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel-header-title {\r\n  color: white !important;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel-header-title:hover {\r\n  color: #fff !important;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel-header:hover {\r\n  color: #fff !important;\r\n  background-color: #00bbbb !important;\r\n}\r\n\r\n.username_fonticon {\r\n  font-size: 18px;\r\n  top: 8px;\r\n  position: relative;\r\n  right: 1%;\r\n}\r\n\r\n.logout_fonticon {\r\n  position: relative;\r\n  top: 10px;\r\n  font-size: 20px;\r\n  right: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.userrole {\r\n  font-size: 13px;\r\n  position: relative;\r\n  color: #05bdd5;\r\n  width: fit-content;\r\n  padding-right: 2%;\r\n}\r\n\r\n.svg_userrole {\r\n  position: absolute;\r\n  color: black;\r\n  font-size: 21px;\r\n  top: -5px;\r\n}\r\n.svg_timzone {\r\n  position: absolute;\r\n  color: black;\r\n  font-size: 16px;\r\n  top: -1px\r\n}\r\n\r\n.locklabel_style {\r\n  left: 4%;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel-header {\r\n  color: white;\r\n  height: 39px !important;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel-body {\r\n  background-color: #304065;\r\n  padding: 0 !important;\r\n  max-height: 165px;\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.accroidiaon_label {\r\n  left: 7%;\r\n  top: 20%;\r\n  font-size: 13px;\r\n}\r\n\r\n// !<--- sidenavBarCss ---->\r\n.caret_css {\r\n  color: black;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  position: relative;\r\n  top: 1px;\r\n}\r\n\r\n.roles_css {\r\nmin-height: 30px !important;\r\nwidth: 170px !important;\r\n\r\n.mat-ripple .mat-mdc-menu-ripple{\r\n  height: 30px !important;\r\n}\r\n}\r\n::ng-deep.mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text {\r\n  font-size: 12px !important;\r\n}\r\n.mat-mdc-menu-item-text{\r\n  font-size: 12px !important;\r\n}\r\n.highlightedRole {\r\n  min-height: 30px !important;\r\nwidth: 180px !important;\r\n\r\n.mat-ripple .mat-mdc-menu-ripple{\r\n  height: 30px !important;\r\n}\r\n  background-color: #17a2b8;\r\n  color: white;\r\n}\r\n\r\n.highlightedRole:hover {\r\n  min-height: 30px !important;\r\nwidth: 180px !important;\r\n\r\n.mat-ripple .mat-mdc-menu-ripple{\r\n  height: 30px !important;\r\n}\r\n  color: #17a2b8 !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.lock_icon_style {\r\n  position: fixed;\r\n  bottom: 10%;\r\n  left: 0;\r\n  right: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.maticon_style {\r\n  position: relative;\r\n  top: 6px;\r\n  font-size: 22px;\r\n  margin-left: 7%;\r\n  margin-right: 6%;\r\n  cursor: pointer;\r\n}\r\n\r\n.fa_fonts {\r\n  position: relative;\r\n  top: 7%;\r\n  font-size: 20px;\r\n  margin-left: 7%;\r\n  margin-right: 6%;\r\n  cursor: pointer;\r\n}\r\n\r\n.fa_fonts_lock {\r\n  position: relative;\r\n  top: 7%;\r\n  font-size: 20px;\r\n  margin-left: 8%;\r\n  margin-right: 6%;\r\n  cursor: pointer;\r\n}\r\n\r\n.fa_fonts_fork {\r\n  position: relative;\r\n  top: 7%;\r\n  font-size: 20px;\r\n  margin-left: 9%;\r\n  margin-right: 8%;\r\n  cursor: pointer;\r\n}\r\n\r\n.createfork {\r\n  position: relative;\r\n  top: 5%;\r\n  margin-left: 9%;\r\n  margin-right: 8%;\r\n  cursor: pointer;\r\n}\r\n\r\n.fa_fonts_submenu {\r\n  position: relative;\r\n  left: 0;\r\n  top: 0%;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-panel-header {\r\n  padding: 0 6px 0 18px !important;\r\n}\r\n\r\n::ng-deep.main-menu .mat-expansion-indicator::after {\r\n  color: inherit !important;\r\n  display: none !important;\r\n}\r\n\r\n.submenu_li {\r\n  height: 21px !important;\r\n  padding-left: 18% !important;\r\n  padding-block: 3% !important;\r\n}\r\n\r\n.role_icon {\r\n  width: 15px !important;\r\n  position: relative !important;\r\n  top: -1px !important;\r\n  cursor: pointer !important;\r\n}\r\n\r\n.mat_icon_normal {\r\n  font-size: 22px;\r\n  margin-left: 7%;\r\n  margin-right: 6%;\r\n  cursor: pointer;\r\n  margin-block: 4%;\r\n}\r\n\r\n.sublist_icon {\r\n  font-size: 18px;\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n.nav_height {\r\n  max-height: calc(100vh - 20vh) !important;\r\n  overflow-x: hidden;\r\n  overflow-y: overlay;\r\n}\r\n\r\n.menu_show {\r\n  margin-left: 56px;\r\n  overflow-x: hidden;\r\n  height: calc(100vh - 7vh) !important;\r\n}\r\n\r\n.menu_hide {\r\n  margin-left: 0px !important;\r\n  overflow-x: hidden !important;\r\n  height: 100vh !important;\r\n}\r\n::ng-deep.mat_tab_styles {\r\n  .mat-mdc-tab-label-container {\r\n    background-color: #dbdada !important;\r\n  .mat-mdc-tab-labels {\r\n    height: 30px !important;\r\n  }\r\n  .mat-mdc-tab{\r\n    font-weight: 600;\r\n    font-size: 12px;\r\n    bottom: 6px;\r\n    letter-spacing:normal;\r\n    border-right: 1px solid #bfbfbf;\r\n  }\r\n  .mat-mdc-tab{\r\n    .mdc-tab__text-label{\r\n      position: relative;\r\n      bottom: 7%;\r\n      color: black;\r\n    }\r\n  }\r\n    .mat-mdc-tab.mdc-tab--active{\r\n      background-color: white !important;\r\n      opacity: unset !important;\r\n      .mdc-tab__text-label {\r\n      color:  #17a0b4 !important;\r\n      \r\n    }\r\n    .mdc-tab-indicator .mdc-tab-indicator__content {\r\n      background-color: #17a0b4 !important;\r\n    height: 14px;\r\n    border-color: transparent;\r\n    }\r\n  }\r\n}\r\n.mat-mdc-tab-body-wrapper {\r\n  .mat-mdc-tab-body-content {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n  }\r\n  ::ng-deep.matoutlinestyles.mat-mdc-form-field{ \r\n    width: 100%;\r\n    .mdc-text-field--outlined {\r\n      padding: 8px !important;\r\n    }\r\n    .mat-mdc-text-field-wrapper{\r\n      .mat-mdc-form-field-flex {\r\n        height: 30px !important;\r\n        .mdc-notched-outline .mdc-floating-label{\r\n            font-size: 11px !important;\r\n        }\r\n        .mat-mdc-input-element{\r\n          position: relative;\r\n          font-size: 12px !important;\r\n        }\r\n        .mat-mdc-form-field-infix{\r\n          bottom: 11px !important;\r\n        }\r\n      }\r\n   }\r\n   .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n  }\r\n  ::ng-deep.mat-mdc-option{\r\n    font-size: 12px !important;\r\n  }\r\n  ::ng-deep.mat-mdc-select {\r\n    font-size: 12px !important;\r\n  }\r\n  // Lower modal backdrop z-index so side nav and tabs appear above it\r\n::ng-deep.modal-backdrop.show {\r\n  height: 84vh;\r\n    top: 16%;\r\n    width: 95vw;\r\n    left: 4.5%;\r\n  z-index: 1049 !important;\r\n    }\r\n// Ensure modal itself appears above side nav\r\n::ng-deep .modal.show {\r\n  z-index: 1050 !important;\r\n  height: 80vh;\r\n  width: 88vw;\r\n  left: 12%;\r\n  top: 16%;\r\n}\r\n// Ensure side nav and tab headers appear above modal backdrop but below modal\r\n::ng-deep mat-sidenav-container {\r\n  z-index: 1040 !important;\r\n  position: relative;\r\n  isolation: isolate;\r\n}\r\n::ng-deep mat-sidenav {\r\n  z-index: 1040 !important;\r\n  position: relative;\r\n  isolation: isolate;\r\n}\r\n::ng-deep .mat-tab-header {\r\n  z-index: 1040 !important;\r\n  position: relative;\r\n}\r\n::ng-deep .mat-tab-group {\r\n  position: relative;\r\n  z-index: 1040 !important;\r\n}\r\n::ng-deep .mdc-switch:enabled{\r\n  .mdc-switch__track::after {\r\n  background:$btn-color;\r\n  }\r\n}\r\n::ng-deep.mat-mdc-slide-toggle {\r\n  --mdc-switch-selected-pressed-handle-color:$btn-color;\r\n}\r\n::ng-deep.mat-mdc-slide-toggle-checked .mdc-switch__shadow {\r\n   background-color: $btn-color ;\r\n   }\r\n\r\n\r\n   ::ng-deep.matchipstyles .mat-mdc-form-field{\r\n    width: 100% !important;\r\n    position: relative !important;\r\n    bottom: 8px !important;\r\n    .mat-mdc-text-field-wrapper{\r\n      background-color: white !important;\r\n      overflow-y: auto !important;\r\n      .mdc-line-ripple{\r\n        display: none !important;\r\n      }\r\n      .mat-mdc-form-field-focus-overlay{\r\n        background-color: white !important;\r\n      }\r\n      .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n        padding-top: 5px  !important;\r\n        max-height: 250px !important;\r\n        padding-bottom: 0px !important;\r\n        min-height: 42px !important;\r\n        .mat-mdc-input-element{\r\n          font-size: 12px !important;\r\n          width: 150px ;\r\n          flex: 1 0 150px !important;\r\n          margin-left: 4px;\r\n        }\r\n        .mat-mdc-chip{\r\n          height: 24px !important;\r\n          float: left !important;\r\n          margin-inline: 1px !important;\r\n          .mdc-evolution-chip__text-label{\r\n            font-size: 12px !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .mat-focused {\r\n      .mat-mdc-text-field-wrapper{\r\n      background-color: white !important;\r\n      .mdc-line-ripple{\r\n        display: none !important;\r\n      }\r\n      .mat-mdc-form-field-focus-overlay{\r\n        background-color: white !important;\r\n      }\r\n      .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n        display: flex !important;\r\n        padding-top: 5px  !important;\r\n        .mat-mdc-input-element{\r\n          font-size: 12px !important;\r\n          width: 150px !important;\r\n          flex: 1 0 150px !important;\r\n          margin-left: 4px;\r\n        }\r\n        .mat-mdc-chip{\r\n          height: 24px !important;\r\n          float: left !important;\r\n          margin-inline: 1px !important;\r\n          .mdc-evolution-chip__text-label{\r\n            font-size: 12px !important;\r\n          }\r\n        }\r\n      }\r\n      }\r\n      .mat-mdc-form-field-subscript-wrapper{\r\n        display: none !important;\r\n      }\r\n    }\r\n    .mat-mdc-form-field-subscript-wrapper{\r\n      display: none !important;\r\n    }\r\n  }\r\n  ::ng-deep.mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked+.mdc-radio__background  {\r\n    .mdc-radio__outer-circle{\r\n    border-color: $btn-color;\r\n    }\r\n    .mdc-radio__inner-circle{\r\n      border-color: $btn-color;\r\n    }\r\n  }\r\n  ::ng-deep.matselectstyles{\r\n    font-size: 11px !important;\r\n    border-radius: 5px !important;\r\n    height: 30px !important;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n    overflow: auto;\r\n    .mat-mdc-text-field-wrapper{\r\n      background-color: white !important;\r\n      .mat-mdc-select{\r\n        position: relative !important;\r\n        bottom: 13px !important;\r\n        font-size: 11px !important;\r\n      }\r\n      .mdc-line-ripple{\r\n        display: none !important;\r\n      }\r\n    }\r\n     .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n  }\r\n  ::ng-deep.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background{\r\n    background-color: $btn-color ;\r\n    border-color: $btn-color ;\r\n    .mdc-checkbox__mixedmark{\r\n      border-color: white !important;\r\n    }\r\n  }\r\n\r\n  ::ng-deep.tabclosebtn{\r\n    .mat-mdc-button-persistent-ripple {\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-focus-indicator{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-button-touch-target{\r\n      display: none !important;\r\n    }\r\n    .mat-ripple .mat-mdc-button-ripple{\r\n      display: none !important;\r\n    }\r\n  }\r\n\r\n.no-records{\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n    height: 100%;\r\n    width: 100%;\r\n    font-size: 18px;\r\n    color: #808080b5;\r\n}\r\n.timezone-switch {\r\n  margin-left: 18px;\r\n}\r\n\r\n.timezone-switch .svg_userrole {\r\n  color: #1976d2; // match role icon color if needed\r\n}\r\n\r\n// Timezone-specific dropdown panel styles\r\n::ng-deep.timezone-dropdown-panel .mat-mdc-menu-content {\r\n  padding-block: 0 !important;\r\n  min-width: 80px !important;\r\n  width: 80px !important;\r\n}\r\n\r\n::ng-deep.timezone-dropdown-panel.mat-mdc-menu-panel {\r\n  min-height: 0 !important;\r\n  min-width: 80px !important;\r\n  width: 80px !important;\r\n}\r\n\r\n// Timezone-specific dropdown styles\r\n.timezone-dropdown-item {\r\n  min-height: 30px !important;\r\n  width: 80px !important;\r\n  color: #333;\r\n  font-size: 12px !important;\r\n  \r\n  .mat-ripple .mat-mdc-menu-ripple {\r\n    height: 30px !important;\r\n  }\r\n}\r\n\r\n.timezone-dropdown-item-selected {\r\n  min-height: 30px !important;\r\n  width: 80px !important;\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  font-weight: bold;\r\n  font-size: 12px !important;\r\n  \r\n  .mat-ripple .mat-mdc-menu-ripple {\r\n    height: 30px !important;\r\n  }\r\n}\r\n\r\n.timezone-dropdown-item-selected:hover {\r\n  min-height: 30px !important;\r\n  width: 80px !important;\r\n  color: #17a2b8 !important;\r\n  cursor: pointer;\r\n  \r\n  .mat-ripple .mat-mdc-menu-ripple {\r\n    height: 30px !important;\r\n  }\r\n}\r\n\r\n// Role dropdown panel — same pattern as timezone-dropdown-panel; pairs with xPosition=\"before\" on header trigger\r\n::ng-deep.roles-dropdown-panel .mat-mdc-menu-content {\r\n  padding-block: 0 !important;\r\n  min-width: 180px !important;\r\n}\r\n\r\n::ng-deep.roles-dropdown-panel.mat-mdc-menu-panel {\r\n  min-height: 0 !important;\r\n  min-width: 180px !important;\r\n}\r\n\r\n// Override global VSstyles align-self:flex-start on menu overlays (pins panel to left of viewport)\r\n::ng-deep .cdk-overlay-pane:has(.roles_dropdown_style.mat-mdc-menu-panel) {\r\n  align-self: auto !important;\r\n}\r\n\r\n.lock_screen_modal {\r\n  z-index: 10000 !important;\r\n  height: 101vh !important;\r\n  width: 100% !important;\r\n  left: 0% !important;\r\n  top: 0% !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
